/* VAT display toggle (18 Sep 2026)
   ============================================================================
   This file does NOT decide what a price looks like. The visible state is an
   attribute on <html> plus the rules in component-vat-toggle-custom.css, and
   that attribute is written by a short inline script in layout/theme.liquid
   before first paint. All this file does is respond to a click and keep
   aria-checked honest.

   Splitting it that way is the whole point: deferred JavaScript runs after the
   page has painted, so if the choice were applied here every visitor whose
   saved preference is inc VAT would watch the site's prices jump on load.

   The click handler is delegated from document rather than bound to the
   buttons, because both the header and the cart icon are re-rendered from
   Shopify's Section Rendering API during ordinary use, which replaces the
   button nodes.
   ========================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'stowpro-vat-mode';

  function currentMode() {
    return document.documentElement.getAttribute('data-vat') === 'inc' ? 'inc' : 'ex';
  }

  /* Keep every switch on the page reporting the real state. There is normally
     one, but a section re-render can swap in another carrying the
     server-rendered default, and nothing here assumes a count. */
  function syncSwitches() {
    var isInc = currentMode() === 'inc';
    var switches = document.querySelectorAll('[data-vat-toggle]');
    for (var i = 0; i < switches.length; i++) {
      switches[i].setAttribute('aria-checked', isInc ? 'true' : 'false');
    }
  }

  function setMode(mode) {
    document.documentElement.setAttribute('data-vat', mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* Private browsing, or site data blocked. The choice still applies for
         this page view, it just will not be remembered. Nothing else depends
         on the write succeeding, so there is nothing to report. */
    }
    syncSwitches();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-vat-toggle]');
    if (!button) return;
    setMode(currentMode() === 'inc' ? 'ex' : 'inc');
  });

  /* A switch is a button, so Space and Enter already fire click. Nothing to
     add for the keyboard. */

  syncSwitches();
  document.addEventListener('shopify:section:load', syncSwitches);
})();
